import { loadSwiper } from "@theme/swiper-loader";
const DEFAULT_SLIDES_PER_VIEW = "1.2";
const DEFAULT_BREAKPOINTS = {
  "640": { slidesPerView: 2, spaceBetween: 16 },
  "1024": { slidesPerView: 3, spaceBetween: 20 }
};
function parseSlidesPerView(raw) {
  if (raw === "auto") return "auto";
  const n = Number(raw);
  return Number.isFinite(n) ? n : 1;
}
class SwiperCarousel extends HTMLElement {
  observer = null;
  morphObserver = null;
  upgraded = false;
  connectedCallback() {
    const src = this.getAttribute("data-bundle-url");
    if (!src) return;
    this.observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            this.observer?.disconnect();
            void this.upgrade(src);
            break;
          }
        }
      },
      { rootMargin: "200px 0px" }
    );
    this.observer.observe(this);
    this.morphObserver = new MutationObserver(() => {
      if (!this.upgraded) return;
      if (!this.querySelector(":scope > ul")) return;
      this.upgraded = false;
      delete this.dataset.upgraded;
      void this.upgrade(src);
    });
    this.morphObserver.observe(this, { childList: true });
  }
  disconnectedCallback() {
    this.observer?.disconnect();
    this.morphObserver?.disconnect();
  }
  async upgrade(src) {
    if (this.upgraded) return;
    this.upgraded = true;
    await loadSwiper(src);
    const list = this.querySelector(":scope > ul");
    if (!(list instanceof HTMLUListElement)) return;
    const items = Array.from(list.children).filter(
      (el) => el instanceof HTMLLIElement
    );
    if (items.length === 0) return;
    const slidesPerView = this.getAttribute("data-slides-per-view") ?? DEFAULT_SLIDES_PER_VIEW;
    const breakpointsRaw = this.getAttribute("data-breakpoints");
    const breakpoints = breakpointsRaw ? JSON.parse(breakpointsRaw) : DEFAULT_BREAKPOINTS;
    const prevEl = this.querySelector("[data-carousel-prev]");
    const nextEl = this.querySelector("[data-carousel-next]");
    const hasExternalNav = prevEl !== null && nextEl !== null;
    const container = document.createElement("swiper-container");
    container.setAttribute("init", "false");
    for (const li of items) {
      const slide = document.createElement("swiper-slide");
      while (li.firstChild) slide.appendChild(li.firstChild);
      container.appendChild(slide);
    }
    list.replaceWith(container);
    container.style.width = this.offsetWidth + "px";
    const isMobile = window.innerWidth < 768;
    const autoHeight = this.getAttribute("data-auto-height") !== "false";
    if (!isMobile || !autoHeight) {
      container.classList.add("swiper-fill-host");
    }
    Object.assign(container, {
      slidesPerView: parseSlidesPerView(slidesPerView),
      spaceBetween: 16,
      autoHeight: isMobile && autoHeight,
      breakpoints,
      keyboard: this.getAttribute("data-keyboard") !== "false",
      a11y: true,
      navigation: hasExternalNav ? { prevEl, nextEl } : false
    });
    container.initialize();
    this.dataset.upgraded = "true";
    this.style.visibility = "";
  }
}
if (!customElements.get("swiper-carousel")) {
  customElements.define("swiper-carousel", SwiperCarousel);
}
